/**
 * List of options for the Movement types field
 *
 * @namespace tmrMovementTypes
 * @type {ngConstant}
 * @todo Mettere i nuovi tipi di movement
 */
export const constant = [
  'tmrMovementTypes',
  {
    MovementDto: 'MOVEMENTTYPES.MOVEMENT',
    EncodingDto: 'MOVEMENTTYPES.ENCODING',
    InboundDto: 'MOVEMENTTYPES.INBOUND',
    InventoryConfirmationDto: 'MOVEMENTTYPES.INVENTORYCONFIRMATION',
    OutboundDto: 'MOVEMENTTYPES.OUTBOUND',
    TransferToZoneDto: 'MOVEMENTTYPES.TRANSFERTOZONE',
    SaleDto: 'MOVEMENTTYPES.SALE',
    ReturnDto: 'MOVEMENTTYPES.RETURN',
    OutboundShippingDto: 'MOVEMENTTYPES.OUTBOUNDSHIPPING',
    InboundShippingDto: 'MOVEMENTTYPES.INBOUNDSHIPPING',
  },
]

/**
 * Translates {@link tmrMovementTypes}
 *
 * @type {ngRun}
 */
let tmrMovementTypesRun = /*@ngInject*/ (TmrTranslate, tmrMovementTypes) =>
  TmrTranslate.object(tmrMovementTypes)

export { tmrMovementTypesRun as run }
